import { CheckCircleIcon, MagnifyingGlassIcon, UserIcon, UserPlusIcon } from "@heroicons/react/20/solid";
import { connect } from "react-redux";
import { Link } from "react-router-dom";
import { Actions as EMPLOYEEACTIONS } from "../../../store/actions/employeeActions";
import Tooltip from "@/tooltip";

const FinalConfirmation = ({ employee, nextPage, sendInvite, agreementId, isSetup }) => {
	return (
		<>
			<div
				style={{
					color: "#ea611c",
					textAlign: "center",
					margin: "auto",
					paddingTop: "5rem",
					width: "15rem",
					position: "relative",
				}}
			>
				<UserIcon style={{ background: "white", borderRadius: "100rem", border: "solid 1rem" }} />
				<CheckCircleIcon
					style={{
						position: "absolute",
						background: "white",
						borderRadius: "5rem",
						height: "7.5rem",
						right: 0,
						top: "13.75rem",
					}}
				/>
				<div style={{ color: "rgb(35, 42, 50" }}>
					<h4>{`${employee?.givenName || "An "} ${employee?.familyName || "Employee"}`}</h4>
					<h5>has been added to your company!</h5>
				</div>
			</div>

			<div style={{ display: "flex", justifyContent: "center", marginTop: "2rem" }}>
				{employee.email && (
					<button
						className="btn btn-success"
						style={{ marginRight: 10 }}
						onClick={() => {
							sendInvite(agreementId);
						}}
						disabled={isSetup}
					>
						<Tooltip
							content={"Cannot invite Employees during Setup"}
							isOpen={isSetup ? undefined : false}
							arrowSize={4}
							distance={10}
						>
							<UserPlusIcon style={{ height: "1.5em", float: "left" }} />
							<div style={{ float: "left", paddingLeft: 5 }}>Invite Employee</div>
						</Tooltip>
					</button>
				)}
				<button
					className="btn btn-default"
					onClick={nextPage}
					style={{ marginRight: 10 }}
				>
					Close
				</button>
				<Link
					to={`/organisation/people/${agreementId}`}
					className="btn btn-success"
					onClick={nextPage}
				>
					<MagnifyingGlassIcon style={{ height: "1.5em", float: "left" }} />
					<div style={{ float: "left", paddingLeft: 5 }}>View Employee</div>
				</Link>
			</div>
		</>
	);
};

const mapStateToProps = (state) => {
	return {
		employee: state.employee?.agreementInfo?.employeeDetails || {},
		agreementId: state.employee?.agreementInfo?.id,
		isSetup: state.company?.settings?.status === "Setup",
	};
};

const mapDispatchToProps = (dispatch) => ({
	sendInvite: (agreementId) => dispatch(EMPLOYEEACTIONS.sendInvite(agreementId)),
});

export default connect(mapStateToProps, mapDispatchToProps)(FinalConfirmation);
